import React from "react";
import { Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

interface InfoTooltipProps {
  title: string;
}

export const InfoTooltip: React.FC<InfoTooltipProps> = ({ title }) => (
  <Tooltip title={title} arrow placement="top">
    <InfoOutlinedIcon
      sx={{
        fontSize: 16,
        color: "text.disabled",
        cursor: "help",
        ml: 0.5,
        verticalAlign: "middle",
        "&:hover": { color: "text.secondary" },
      }}
    />
  </Tooltip>
);
